<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
}
</script>

<style lang="scss">
  #app{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?31dba93f